import { SessionPersistConstants } from './sessionPersist.constants'
import { ISessionPersistAction, ISessionPersistState } from './sessionPersist.types'

export const initialSessionPersistState: ISessionPersistState = {
  isHydrating: false,
  showModal: false,
  pinValues: [],
  isResuming: false,
  errorMessage: '',
  metadata: null,
}

export function sessionPersistReducer(
  state: ISessionPersistState = initialSessionPersistState,
  action: ISessionPersistAction
): ISessionPersistState {
  switch (action.type) {
    case SessionPersistConstants.SET_IS_HYDRATING:
      return { ...state, isHydrating: action.isHydrating }
    case SessionPersistConstants.SET_SHOW_MODAL:
      return { ...state, showModal: action.showModal }
    case SessionPersistConstants.SET_PIN_VALUES:
      return { ...state, pinValues: action.pinValues }
    case SessionPersistConstants.SET_IS_RESUMING:
      return { ...state, isResuming: action.isResuming }
    case SessionPersistConstants.SET_ERROR_MESSAGE:
      return { ...state, errorMessage: action.errorMessage }
    case SessionPersistConstants.SET_METADATA:
      return { ...state, metadata: action.metadata }
    case SessionPersistConstants.RESET_STATE:
      return initialSessionPersistState
    default:
      return state
  }
}
